export interface NotificationCustomConfig {
  notification_id?: string | null;
  group?: string | null;
  channels: string[];
  preference?: string;
}

export default class AgentNotificationConfigDomain {
  handle: string | null;

  contactChannel: string;

  preference: string;

  strategy: string;

  timezone: string;

  disabledChannels: string[];

  customConfigs: NotificationCustomConfig[];

  constructor(
    handle: string | null,
    contactChannel: string,
    preference: string,
    strategy: string,
    timezone: string,
    disabledChannels: string[] = [],
    customConfigs: NotificationCustomConfig[] = []
  ) {
    this.handle = handle;
    this.contactChannel = contactChannel;
    this.preference = preference;
    this.strategy = strategy;
    this.timezone = timezone;
    this.disabledChannels = disabledChannels;
    this.customConfigs = customConfigs;
  }
}
